import React from "react";
import type { DialogProps } from "../DialogBase";
import { DialogBase } from "../DialogBase";
import { onCloseDialog } from "../util";

export const Passive = ({
  title,
  onClose,
  open,
  children,
  ariaLabelCloseIcon,
  ariaLabel,
  onDismissFocusRef,
  icon,
  illustration,
  alignIllustration,
  width,
  dataTestId,
  hideCloseButton,
  dialogAlignment,
  drawerSize,
}: DialogProps): React.JSX.Element | null => {
  const closeHandler = (): void =>
    onCloseDialog({ onDismissFocusRef, onClose });

  if (!open) {
    return null;
  }

  return (
    <DialogBase
      alignIllustration={alignIllustration}
      ariaLabel={ariaLabel}
      open={open}
      title={title}
      onClose={closeHandler}
      ariaLabelCloseIcon={ariaLabelCloseIcon}
      onDismissFocusRef={onDismissFocusRef}
      icon={icon}
      illustration={illustration}
      dataTestId={dataTestId}
      width={width}
      hideCloseButton={hideCloseButton}
      dialogAlignment={dialogAlignment}
      drawerSize={drawerSize}
    >
      {children}
    </DialogBase>
  );
};
